<h1 mat-dialog-title>
	<mat-icon *ngIf="type === 'error'">error</mat-icon>
	{{ title }}
</h1>
<div mat-dialog-content [innerHTML]="message | safeHtml"></div>
<div mat-dialog-actions>
	<button mat-raised-button (click)="dialogRef.close(true)" cdkFocusInitial>{{ buttonText }}</button>
</div>
